// hooks/useMovementsApi.ts
import type {
    ArtworkMovementDto,
    MovementSummaryDto,
    CreateMovementRequest,
    RecordReturnRequest,
} from "../models/Movement";
import type { ArtworkStatusRefData } from "../models/ArtworkStatus";
import { useApiClient } from "../components/useApiClient";

export function useMovementsApi() {
    const { get: getJson, postJson } = useApiClient();

    async function getSummary(accessToken: string): Promise<MovementSummaryDto> {
        return getJson<MovementSummaryDto>("movements/summary", accessToken);
    }

    async function getActive(accessToken: string): Promise<ArtworkMovementDto[]> {
        return getJson<ArtworkMovementDto[]>("movements/active", accessToken);
    }

    async function getStatuses(accessToken: string): Promise<ArtworkStatusRefData[]> {
        return getJson<ArtworkStatusRefData[]>("artwork-statuses", accessToken);
    }

    async function getArtworkHistory(
        artworkId: number,
        accessToken: string
    ): Promise<ArtworkMovementDto[]> {
        return getJson<ArtworkMovementDto[]>(
            `movements/artwork/${artworkId}/history`,
            accessToken
        );
    }

    async function createMovement(
        dto: CreateMovementRequest,
        accessToken: string
    ): Promise<ArtworkMovementDto> {
        return postJson<ArtworkMovementDto>("movements", accessToken, dto);
    }

    async function recordReturn(
        dto: RecordReturnRequest,
        accessToken: string
    ): Promise<ArtworkMovementDto> {
        return postJson<ArtworkMovementDto>("movements/return", accessToken, dto);
    }

    return {
        getSummary,
        getActive,
        getStatuses,
        getArtworkHistory,
        createMovement,
        recordReturn,
    };
}